// AIRのシートクラス WIN提供データ
const seatClass = [
  {
    value: 1,
    string: 'P',
    ja: 'プレミアムファースト',
  },
  {
    value: 2,
    string: 'F',
    ja: 'ファースト',
  },
  {
    value: 3,
    string: 'J',
    ja: 'プレミアムビジネス',
  },
  {
    value: 4,
    string: 'C',
    ja: 'ビジネス',
  },
  {
    value: 5,
    string: 'S',
    ja: 'プレミアムエコノミー',
  },
  {
    value: 6,
    string: 'Y',
    ja: 'エコノミー',
  },
]

export default seatClass
